import SportradarOverview from './SportradarOverview'
import SportradarSettings from './SportradarSettings'
import LiveActivityTestTool from './LiveActivityTestTool.vue'

export default Object.freeze({
  type: 'sportradar',
  title: 'Integrations_Sportradar',
  category: 'Integrations_Sportradar_Category',
  description: 'Integrations_Sportradar_Description',
  deletePrompt: 'Integrations_Sportradar_DialogDelete_Prompt',
  deactivatePrompt: 'Integrations_Sportradar_DialogDeactivate_Prompt',
  image: require('@/img/integrations/sportradar.png'),
  requiresAdmin: false,
  components: {
    overview: SportradarOverview,
    settings: SportradarSettings,
    testTool: LiveActivityTestTool
  },
  urls: {
    guide: 'https://docs.xtremepush.com/docs/sportradar'
  }
})



// WEBPACK FOOTER //
// ./src/modules/integrations/types/sportradar/index.js